module.exports = __webpack_public_path__ + "assets/img/news.5dde3611.png";